"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const Popover_1 = __importDefault(require("@material-ui/core/Popover"));
const KeyCodes_1 = __importDefault(require("@opsbase/lib-general/KeyCodes"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const TextField_1 = __importDefault(require("@opsbase/web-textfield/TextField"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
function QuestionEditorScoringButtonMenu(props) {
    const { score = 'N/A', onChange, disabled } = props;
    const [stateScore, setStateScore] = (0, react_1.useState)(String(score));
    const [menuEl, setMenuEl] = (0, react_1.useState)();
    const handleKeyPress = (0, react_1.useCallback)((e) => {
        if (e.keyCode === KeyCodes_1.default.ENTER) {
            e.preventDefault();
            e.stopPropagation();
            setMenuEl(null);
        }
    }, []);
    const handleBlur = (0, react_1.useCallback)(v => {
        onChange(parseFloat(v));
    }, [onChange]);
    const handleChange = (0, react_1.useCallback)(v => {
        if (v === '') {
            setStateScore('');
        }
        if (isNaN(parseFloat(v))) {
            if (v === '-') {
                setStateScore('');
            }
        }
        else {
            const value = (v + '').split('.');
            if (value.length == 2 && value[1].length >= 3) {
                setStateScore(value[0] + '.' + value[1].slice(0, 2));
            }
            else {
                setStateScore(v);
            }
        }
    }, [setStateScore]);
    const handleStopProp = (0, react_1.useCallback)(e => e.stopPropagation(), []);
    const placeholder = score === null || score === 'N/A' ? 'N/A' : 'Enter score';
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { color: lib_palette_1.default.secondary, disabled: disabled, small: true, onClick: e => setMenuEl(e.target.parentNode), margin: '0 0 0 0px', style: { fontSize: 12, minWidth: 45 } }, score == null ? 'N/A' : String(score)),
        react_1.default.createElement(Popover_1.default, { open: !!menuEl, anchorEl: menuEl, onClose: () => setMenuEl(null), anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            } },
            react_1.default.createElement(Vertical_1.default, { padding: true, gutter: true },
                react_1.default.createElement(TextField_1.default, { autoFocus: true, type: 'number', disabled: score === null || score === 'N/A', value: String(stateScore), onClick: handleStopProp, onKeyDown: handleKeyPress, onBlur: handleBlur, onChange: handleChange, placeholder: placeholder, InputProps: {
                        endAdornment: react_1.default.createElement(core_1.InputAdornment, { position: "end" }, "Points"),
                    } })))));
}
exports.default = QuestionEditorScoringButtonMenu;
